import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { message } from "antd"
import List from "app/stores/list"
import { getToken } from "app/api/localTools"

export default class Store {
  @observable recoveryTableData = []
  @observable shareList = []
  @observable list
  @observable detailData = {}
  @observable versionType = ''
  @observable versions = []
  @observable summaries = []
  @observable summariesPlus = []
  @observable summariesAdvice = []
  @observable selectedRows = []
  @observable selectedRowKeys = []
  @observable innerResult = []
  @observable annResult = []
  @observable cnvGuide = []
  @observable outboundKey=''
  @observable exportModalShowed = false
  @observable DiagnosisList = []

  @action onSelect = (record, selected) => {
    if (selected) {
      this.selectedRows = [...this.selectedRows, record],
      this.selectedRowKeys = [...this.selectedRowKeys, record.groupId]
    }
    if (!selected) {
      let copySelectedRows = [...this.selectedRows]
      let copySelectedRowKeys = [...this.selectedRowKeys]
      let delIdx = null
      for (let i = 0; i < copySelectedRowKeys.length; i++) {
        if (copySelectedRowKeys[i] === record.groupId) {
          delIdx = i
          break
        }
      }
      copySelectedRows.splice(delIdx, 1)
      copySelectedRowKeys.splice(delIdx, 1)

      this.selectedRows = copySelectedRows,
      this.selectedRowKeys = copySelectedRowKeys
    }
  }

  @action onSelectAll = (selected, rows, changeRows) => {
    const changeRowIds = changeRows.map((item) => item.groupId)
    if (selected) {
      this.selectedRows = [...this.selectedRows, ...changeRows]
      this.selectedRowKeys = [...this.selectedRowKeys, ...changeRowIds]
    }
    if (!selected) {
      let copySelectedRows = [...this.selectedRows]
      let copySelectedRowKeys = [...this.selectedRowKeys]
      copySelectedRowKeys = copySelectedRowKeys.filter(function (item) {
        return changeRowIds.indexOf(item) === -1
      })
      copySelectedRows = copySelectedRows.filter(function (item) {
        return changeRowIds.indexOf(item.groupId) === -1
      })
      this.selectedRowKeys = copySelectedRowKeys
      this.selectedRows = copySelectedRows
    }
  }
    
  @action setVersionType = (type) => {
    this.versionType = type
  }

  @action getVersions = (groupId) => {
    return request.get(`${config.backend}/pgs/groups/${groupId}/versions`)
      .checkToken()
      .commonDispose()
  }

  @action getGroupsTemp = (groupId) => {
    return request.get(`${config.backend}/pgs/groups/${groupId}/template`)
      .checkToken()
      .commonDispose()
  }

  @action setVersions = (versions) => {
    this.versions = versions
  }

  @action getPgscnv = (reportId) => {
    return request.get(`${config.backend}/pgs/cnv/${reportId}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.innerResult = res.innerResult?res.innerResult:[]
          this.annResult = res.annResult?res.annResult:[]
        },
        err => {
          this.innerResult =[]
          this.annResult =[]
          message.error(err.message)
        }
      )
      
  }

  @action getPgscnvGuide = (reportId) => {
    return request.get(`${config.backend}/pgs/cnv/cnvGuide/info`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
         
          this.cnvGuide = res
        },
        err => {
          message.error(err.message)
        }
      )
      
  }
  
  @action conserveCnvGuide = (data, reportId) => {
    return request.post(`${config.backend}/pgs/cnv/${reportId}`)
      .send(data)
      .checkToken()
      .commonDispose()
  }

  @action clearVersions = () => {
    this.versions = []
  }

  @action getDetailData = (reportId) => {
    return request.get(`${config.backend}/pgs/reports/${reportId}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData = res
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action syncSampleInfo = (reportId) => {
    return request.put(`${config.backend}/pgs/datas/samples/${reportId}`)
      .checkToken()
      .commonDispose()
  }

  @action getSummaries = (reportId) => {
    return request.get(`${config.backend}/pgs/reports/${reportId}/summaries`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.summaries = res
          return Promise.resolve()
        },
        err => {
          message.error(err.message)
          return Promise.reject()
        }
      )
  }

  @action getSummariesPlus = (reportId) => {
    return request.get(`${config.backend}/pgs/reports/${reportId}/summariesPlus`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.summariesPlus = res
          return Promise.resolve()
        },
        err => {
          message.error(err.message)
          return Promise.reject()
        }
      )
  }
  @action getSummariesAdvice = (reportId) => {
    return request.get(`${config.backend}/pgs/reports/${reportId}/advice`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.summariesAdvice = res
          return Promise.resolve()
        },
        err => {
          message.error(err.message)
          return Promise.reject()
        }
      )
  }

  @action clearDetailData = () => {
    this.detailData = {}
  }

  @action getExportUrl = (groupId,type) => {
    if(type===2){
      return request.get(`${config.backend}/pgs/reports/${groupId}/allimages?outboundKey=${this.outboundKey}`)
        .checkToken()
        .commonDispose()
    }else{
      return request.get(`${config.backend}/pgs/groups/${groupId}/statistic`) 
      .checkToken()
      .commonDispose()
    }
      
  }
  
  @action downloadStep1 = (groupId, templateId, versionId) => {
    return request.post(
      `${config.backend}/pgs/reports/preview/${groupId}/group/download?templateId=${templateId}&versionId=${versionId}`
    )
      .checkToken()
      .commonDispose()
  }

  @action downloadStep2 = (downloadId) => {
    return request.get(`${config.backend}/pgs/reports/pdf/${downloadId}/status`)
      .checkToken()
      .commonDispose()
  }

  @action shareGroup = (groupId, username) => {
    return request.put(`${config.backend}/pgs/groups/${groupId}/share/${username}`)
      .checkToken()
      .commonDispose()
  }

  @action dataSwitch = (reportId) => {
    return request.get(`${config.backend}/pgs/reports/${reportId}`)
      .checkToken()
      .commonDispose()
  }

  @action deleteReport = (groupId, reportId) => {
    return request.delete(`${config.backend}/pgs/groups/${groupId}/reports/${reportId}`)
      .checkToken()
      .commonDispose()
  }
  @action deleteDiagnosisReport = (groupId, reportId) => {
    return request.delete(`${config.backend}/pgs/reports/test/delete/${reportId}`)
      .checkToken()
      .commonDispose()
  }

  @action recoveryReport = (groupId, reportId) => {
    return request.put(`${config.backend}/pgs/groups/${groupId}/reports/${reportId}/recovery`)
      .checkToken()
      .commonDispose()
  }

  @action getHistory = (groupId) => {
    return request.get(`${config.backend}/pgs/groups/${groupId}/history`)
      .checkToken()
      .commonDispose()
  }

  @action getReportImageUrl = (reportId) => {
    return request.get(`${config.backend}/pgs/reports/${reportId}/images`)
      .checkToken()
      .commonDispose()
  }

  /*
   * @query: 获取数据的类型
   */
  @action getGroupListById = (groupId, query) => {
    return request.get(`${config.backend}/pgs/groups/${groupId}/reports?state=${query}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.recoveryTableData = res
        }
      )
  }
  /*
   * @query: 获取诊断报告列表
   */
  @action getGroupDiagnosisListById = (groupId, query) => {
    return request.get(`${config.backend}/pgs/reports/test/list/${groupId}?status=${query}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.DiagnosisList = res
        }
      )
  }

  @action clearRecoveryTableData = () => {
    this.recoveryTableData = []
  }

  @action updateGroup = (groupId, groupName) => {
    return request.put(`${config.backend}/pgs/groups/${groupId}/reports`)
      .send({ groupName })
      .checkToken()
      .commonDispose()
  }

  @action getReportByAppId = (appId) => {
    return request.get(`${config.backend}/pgs/reports/apps/${appId}`)
      .checkToken()
      .commonDispose()
  }

  @action getSearchData = (appId, keyword) => {
    return request.get(`${config.backend}/pgs/reports/apps/${appId}?keywords=${keyword}`)
      .checkToken()
      .commonDispose()
  }

  @action createNewGroup = (newGroupData) => {
    return request.post(`${config.backend}/pgs/groups/reports`)
      .send(newGroupData)
      .checkToken()
      .commonDispose()
  }

  @action deleteGroup = (id) => {
    return request.delete(`${config.backend}/pgs/groups/${id}/reports`)
      .checkToken()
      .commonDispose()
  }
  @action deleteGroupReport = (id) => {
    return request.delete(`${config.backend}/pgs/groups/${id}/datas`)
      .checkToken()
      .commonDispose()
  }

  @action getShareList = (id) => {
    return request.get(`${config.backend}/pgs/groups/${id}/share`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.shareList = res
        },
        err => {
          message.error(err.message)
        }
      )
  }
  @action exportBatchPdfStatus = (data) => { 
    return request.post(`${config.backend}/pgs/reports/preview/groups/download`)
      .checkToken()
      .send(data)
      .commonDispose()
  }
  
  @action exportBatchPdf = (tempId) => { 
    return request.get(`${config.backend}/pgs/reports/multi/pdf/${tempId}/status`)
      .checkToken()
      .commonDispose()
  }

  @action exportBatchGroup = (data) => {
    return request.post(`${config.backend}/pgs/groups/multi/statistic`)
      .checkToken()
      .send(data.toJS())
      .commonDispose()
  }

  @action exportBatchLink = (data) => {
    return request.post(`${config.backend}/pgs/groups/multi/reports/share`)
      .checkToken()
      .send(data.toJS())
      .commonDispose()
  }

  @action editTracer = (data, reportId) => {
    return request.put(`${config.backend}/pgs/reports/${reportId}`)
      .send(data)
      .checkToken()
      .commonDispose()
  }

  @action cancelShare = (groupId, ownerId, type) => {
    if (type === 'toId') {
      return request.delete(`${config.backend}/pgs/groups/${groupId}/share?${type}=${ownerId}`)
        .checkToken()
        .commonDispose()
        .then(
          res => {
            const index = this.shareList.findIndex(
              shared => {
                return shared.toId === ownerId
              }
            )
            this.shareList.splice(index, 1)
            message.success("取消分享成功")
            return Promise.resolve()
          },
          err => {
            message.error(err.message)
            return Promise.reject()
          }
        )
    } else {
      return request.delete(`${config.backend}/pgs/groups/${groupId}/share`)
        .checkToken()
        .commonDispose()
        .then(
          res => {
            this.list.filterData()
            message.success("取消分享成功")
            return Promise.resolve()
          },
          err => {
            message.error(err.message)
            return Promise.reject()
          }
        )
    }
  }
   /*
   * @query: 获取outboundKey参数
   */
  @action exportConnectWebsocket = () => {
    if (!this.websocket) {
      this.websocket = new WebSocket(`${config.wsUri}/ws/statistics?jwt=${getToken()}`)
    }

    this.websocket.onopen = () => {
      // console.log('websocket oppened')
    }

    this.websocket.onmessage = (event) => {
      const data = JSON.parse(event.data)
      if (data && data.outboundKey) {
        this.outboundKey = data.outboundKey
      }
      if (data && data.url) {
        this.setUrl(data.url)
      }
    }

    this.websocket.onclose = (event) => {
      // console.log('websocket closed：', event)
    }

    this.websocket.onerror = (event) => {
      const data = JSON.parse(event.data)
      if (data.code !== 200) {
        message.error(data.msg)
      }
    }
  }
  @action setUrl = (url) => {
    this.beginDownload(url)
  }
  @action beginDownload = (url) => {
    this.exportModalShowed = false
    if (document.getElementById("export-a-tag")) document.getElementById("export-a-tag").outerHTML = ""
    let a = document.createElement("iframe")
    a.setAttribute("src", url)
    a.setAttribute("id", "export-a-tag")
    a.setAttribute("style", "display:none;")
    if (!document.getElementById("export-a-tag")) document.body.appendChild(a)
  }
  @action closeExportWebsocket = () => {
    if (this.websocket) {
      this.websocket.close()
      this.websocket = null
    }
  }

      /*
   * @query: xiongbo账号根据日期下载染色体点图
   */
      @action getReportImageUrlDate = (startDate,endDate) => {
        const url=`${config.backend}/pgs/report/images/zip?`
        const newUrl=url+`startDate=${startDate}&endDate=${endDate}&outboundKey=${this.outboundKey}`
        return request.get(
          newUrl
        )
          .checkToken()
          .commonDispose()
          .then(
            res => {
              return Promise.resolve()
            },
            err => {
              message.error(err.message)
              this.exportModalShowed = false
            }
          )
      }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "pgs/groups/reports")
    return store
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/pgs/report.js